<template>
    <div id="campaigns-create">
        <div class="col-md-12 text-center" v-if="loading">
            <i class="fa fa-spinner fa-spin inner-loading"></i>
        </div>

        <div class="row" dusk="ready" v-else>
            <div class="col-sm-10 col-sm-offset-1">
                <div class="row page-title">
                    <div class="col-md-12">
                        <h1>Create {{ productCategory.label | capitalize | indefinite }} Campaign </h1>
                        <p></p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <campaign-editor
                            v-model="campaign"
                            :validation="validation"
                            :dimensions="dimensions"
                            :has-select-group="hasSelectGroup"
                            :base-url="baseUrl"
                            :user-roles="userRoles"
                            :show-errors="showErrors">
                        </campaign-editor>

                        <div class="row buttons" v-cloak>
                            <div class="col-md-5">
                                <button id="save_create_ad_set" v-on:click="saveAndRedirect()" class="btn btn-block --gray --gray-border">Save and Create Ad Set</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import campaignCommon from './../../campaigns/common'
import {slugify} from '../../utils.js'
import Swal from "sweetalert2";

export default {
    mixins: [campaignCommon],

    name: 'CampaignCreator',

    props: {
        productCategoryId: Number,
        hasSelectGroup: Boolean,
        userRoles: Array
    },

    data() {
        return {
            campaign: {
                name: '',
                ad_product: this.getDefaultAdProduct(),
                is_advertiser_edit_blocked: false,
                is_bankrate_select: false,
                budgets: [
                    {budget: 0, budget_interval: "9"}
                ],
                start_date: '',
                end_date: ''
            },
            dateStart: {
                time: ''
            },
            dateEnd: {
                time: ''
            },
            campaignNames: [],
            productCategories: [],
            dimensions: {
                ad_products: [],
                budget_intervals: []
            },
            baseUrl: Laravel.baseUrl,
            showErrors: false,
            loading: true,
        }
    },

    computed: {
        validation: function() {
            return {
                name: !!this.campaign.name.trim(),
                nameUnique: _.indexOf(this.campaignNames, this.campaign.name.trim().toLowerCase()) == -1,
                ad_product: typeof this.campaign.ad_product['id'] != 'undefined',
                budget_amount:  !!this.isValidBudgetAmount,
                budget_interval: !!(this.campaign.budgets[0]['budget_interval'] && this.campaign.budgets[0]['budget_interval'] != 'none'),
                budget_end_not_after_start: this.campaign.end_date == '' || moment(this.campaign.start_date).isBefore(this.campaign.end_date, 'day')
            };
        },

        isValidBudgetAmount: function () {
            return this.campaign.budgets.reduce(function (total, budget) { return total + budget.budget; }, 0) > 0 ||
                Number(this.campaign.budgets[0]['budget_interval']) === 9;
        },

        isValid: function () {
            var validation = this.validation;
            return Object.keys(validation).every(function (key) {
                return validation[key];
            })
        },

        productCategory() {
            return _(this.productCategories).find({ id: this.productCategoryId });
        }
    },

    methods: {
        loadNames: function() {
            return this.$http.get(route('api.advertiser.campaign-names', { vertical: this.productCategory.label.toLowerCase() })).then(function(response) {
                if (response.body.success) {
                    this.campaignNames = response.body.campaignNames;
                }
            });
        },

        getProductCategories: function () {
            return this.$http.get(route('api.product-category.index')).then((response) => {
                this.productCategories = response.body.productCategories;
            });
        },

        getDimensions() {
            return this.$http.get(route('campaigns.dimensions.index')).then(function (response) {
                if (response.data.success) {
                    this.dimensions = response.data.dimensions;
                }
            });
        },

        getDefaultAdProduct() {
            if (this.isMortgage() || this.isHomeEquity()) {
                return {
                    id: 2,
                    label: "Cost Per Lead",
                    name: "Cost Per Lead",
                    type: "CPL"
                };
            } else {
                return {
                    id: 1,
                    label: "Cost Per Click",
                    name: "Cost Per Click",
                    type: "CPC"
                };
            }
        },

        isMortgage: function() {
            return this.productCategoryId === 2;
        },

        isHomeEquity: function() {
            return this.productCategoryId === 20;
        },

        save: function(callback) {
            var self = this;

            this.campaign.product_category_id = this.productCategoryId;

            if (!this.isValid) {
                this.showErrors = true;
                return false;
            }

            $.loading.show();
            this.$http.post(route('campaigns.store'), this.campaign).then(function(response) {
                $.loading.hide();

                if (response.body.success) {
                    if (callback) {
                        callback(response.body.campaign);
                    } else {
                        window.location = route(`campaigns.${slugify(self.productCategory.label)}.index`);
                    }
                } else {
                    this.notifyRollbar('Create Campaign Failure: components/campaigns/create.vue@save: line 152', response);
                    this.showErrorMessage();
                }
            }, function(error) {
                this.notifyRollbar('Create Campaign Failure: components/campaigns/create.vue@save: line 152', error);
                this.manageErrors(error)
            });
        },

        saveAndRedirect: function() {
            var self = this;

            this.save(function(campaign) {
                window.location = route('campaigns.adset.create', campaign.id);
            });
        }
    },

    mounted() {
        Promise.all([
            this.getProductCategories(),
            this.getDimensions()
        ]).then(() => {
            return this.loadNames();
        }).then(() => {
            this.loading = false;
        }).catch((error) => {
            new Swal('Whoops!', 'Something went wrong. Please contact support.', 'error');
        });
    }
}
</script>

<style>
    .row.buttons {
        padding-bottom: 20px;
    }
</style>
